import React, { createContext, useContext, useState } from 'react';

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  let initialApiUrl = process.env.REACT_APP_API_URL;
  let initialWebsocketEndpoint = process.env.REACT_APP_WEBSOCKET_ENDPOINT;
  let initialGoogleApiKey = process.env.REACT_APP_GOOGLE_API_KEY;
  let initialGoogleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  let initialContentDomain = process.env.REACT_APP_CONTENT_DOMAIN;

  const [apiUrl, setApiUrl] = useState(initialApiUrl);
  const [websocketEndpoint, setWebsocketEndpoint] = useState(
    initialWebsocketEndpoint
  );
  const [googleApiKey] = useState(initialGoogleApiKey);
  const [googleClientId] = useState(initialGoogleClientId);
  const [env] = useState(process.env.REACT_APP_ENV);
  const [contentDomain, setContentDomain] = useState(initialContentDomain);
  const getLandingPageUrl = (env) => {
    if (env === 'PROD') {
      return 'https://brandvoxai.com';
    } else if (env === 'TEST') {
      return 'https://test.brandvoxai.com';
    } else {
      return 'http://localhost:3002';
    }
  };

  const [landingPageUrl] = useState(
    getLandingPageUrl(process.env.REACT_APP_ENV) || process.env.REACT_APP_LANDING_URL
  );

  return (
    <GlobalContext.Provider
      value={{
        apiUrl,
        setApiUrl,
        websocketEndpoint,
        setWebsocketEndpoint,
        env,
        googleApiKey,
        googleClientId,
        contentDomain,
        setContentDomain,
        landingPageUrl,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => useContext(GlobalContext);
